import { z } from "zod";

export const fileDuplicationItemSchema = z.object({
  sourceId: z.string(),
  sourceName: z.string().nullable(),
  destinationId: z.string().nullable(),
  destinationName: z.string().nullable(),
  isFolder: z.boolean(),
  status: z.enum(["pending", "running", "succeeded", "failed"]),
  errorCode: z.string().nullable(),
  errorMessage: z.string().nullable(),
});

export const fileDuplicationSchema = z.object({
  id: z.string(),
  requestId: z.string(),
  destinationFolderId: z.string().nullable(),
  status: z.enum(["queued", "running", "succeeded", "partial", "failed"]),
  total: z.number().int().nonnegative(),
  succeeded: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
  errorCode: z.string().nullable(),
  errorMessage: z.string().nullable(),
  items: z.array(fileDuplicationItemSchema),
  nextCursor: z.string().nullable(),
});

export type FileDuplication = z.infer<typeof fileDuplicationSchema>;
export type FileDuplicationItem = z.infer<typeof fileDuplicationItemSchema>;

export type FileDuplicationCreate = {
  fileIds: string[];
  destinationFolderId: string | null;
  mode: "folders_and_files" | "folders_only";
  requestId: string;
};

export const isFileDuplicationFinished = (status: FileDuplication["status"]) =>
  status === "succeeded" || status === "partial" || status === "failed";
